/* Velou product tabs — shared behavior for the block rendered by
   snippets/velou-product-tabs.liquid inside [data-velou-tabs-host]
   (sections/product-recommendations.liquid).

   Everything lives here (not inline in the snippet) because HTML injected via
   innerHTML on a product swap never executes its inline scripts, and the
   initial product may render no tabs at all. */
(function () {
  if (window.__velouTabsSetup) return;
  window.__velouTabsSetup = true;

  /* Tabs click handling, delegated at document level so injected tabs work. */
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.velou-tabs__tab');
    if (!tab) return;
    var block = tab.closest('.velou-tabs');
    if (!block) return;

    block.querySelectorAll('.velou-tabs__tab').forEach(function (otherTab) {
      otherTab.setAttribute('aria-selected', otherTab === tab ? 'true' : 'false');
    });
    block.querySelectorAll('.velou-tabs__panel').forEach(function (panel) {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
  });

  /* Re-renders the tabs for another product of the same page. The PDP
     fit/color pickers swap the product without a reload but never touch the
     product-recommendations section, so they call this (or dispatch the
     event below). */
  var latestRequestUrl = null;
  window.replaceVelouProductTabs = function (handleOrUrl) {
    var host = document.querySelector('[data-velou-tabs-host]');
    if (!host || !handleOrUrl) return;
    var sectionEl = host.closest('[id^="shopify-section-"]');
    if (!sectionEl) return;
    var sectionId = sectionEl.id.replace('shopify-section-', '');

    var handle = String(handleOrUrl).split('?')[0].replace(/\/+$/, '');
    handle = handle.slice(handle.lastIndexOf('/') + 1);
    if (!handle) return;

    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    var requestUrl = root + 'products/' + handle + '?section_id=' + encodeURIComponent(sectionId);
    /* Only the response of the most recent swap may render (rapid clicks race) */
    latestRequestUrl = requestUrl;

    fetch(requestUrl)
      .then(function (response) { return response.ok ? response.text() : null; })
      .then(function (html) {
        if (!html || latestRequestUrl !== requestUrl) return;
        var newHost = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-velou-tabs-host]');
        var currentHost = document.querySelector('[data-velou-tabs-host]');
        if (!newHost || !currentHost) return;
        currentHost.innerHTML = newHost.innerHTML;
      })
      .catch(function () {});
  };

  document.addEventListener('fit-color-picker-fixed:product-changed', function (event) {
    var product = event.detail && event.detail.product;
    if (product && product.handle) window.replaceVelouProductTabs(product.handle);
  });
})();
